module.exports = __webpack_public_path__ + "static/leseprobe3_verlage-und-genres_kap10-67044225101543b9b8d5f04a6c79c2d6.pdf";